import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";

var ProfileService = /*#__PURE__*/function () {
  function ProfileService() {
    _classCallCheck(this, ProfileService);
  }

  _createClass(ProfileService, [{
    key: "selectedProvider",
    get: function get() {
      return +localStorage.getItem("selected-provider") || -1;
    }
  }, {
    key: "selectProvider",
    value: function selectProvider(id) {
      localStorage.setItem("selected-provider", id);
    }
  }]);

  return ProfileService;
}();

var profileService = new ProfileService();
export default profileService;